import { default as EmptyStateContainer } from './EmptyState.container';
import { default as EmptyState } from './EmptyState';

export default EmptyStateContainer(EmptyState);
